import client from './client';

const scheduling = {
  // Semesters
  getSemesters:  ()          => client.get('/semesters/'),
  getSemester:   (id)        => client.get(`/semesters/${id}/`),
  createSemester:(data)      => client.post('/semesters/', data),
  updateSemester:(id, data)  => client.patch(`/semesters/${id}/`, data),
  getShiftCounts:(semId)     => client.get(`/semesters/${semId}/shift-counts/`),

  // Periods
  getPeriods:    ()          => client.get('/periods/'),
  getPeriod:     (id)        => client.get(`/periods/${id}/`),
  createPeriod:  (data)      => client.post('/periods/', data),
  updatePeriod:  (id, data)  => client.patch(`/periods/${id}/`, data),
  openPeriod:    (id)        => client.post(`/periods/${id}/open/`),
  closePeriod:   (id)        => client.post(`/periods/${id}/close/`),
  generateSchedule: (id)     => client.post(`/periods/${id}/generate/`),

  // Heavy days
  getHeavyDays:  (periodId)  => client.get(`/heavy-days/?period=${periodId}`),
  createHeavyDay:(data)      => client.post('/heavy-days/', data),
  deleteHeavyDay:(id)        => client.delete(`/heavy-days/${id}/`),

  // Availability
  submitAvailability: (data) => client.post('/availability/submit/', data),
  myResponses: (periodId)    => client.get(`/availability/my-responses/?period=${periodId}`),
  allResponses: (periodId)   => client.get(`/availability/responses/?period=${periodId}`),
  submissionStatus: (periodId) => client.get(`/availability/submission-status/?period=${periodId}`),

  // SL assignments
  getSlAssignments:(semId)   => client.get(`/sl-assignments/?semester=${semId}`),
  createSlAssignment:(data)  => client.post('/sl-assignments/', data),
  deleteSlAssignment:(id)    => client.delete(`/sl-assignments/${id}/`),

  // Do-not-pair
  getDoNotPair:  (semId)     => client.get(`/do-not-pair/?semester=${semId}`),
  createDoNotPair:(data)     => client.post('/do-not-pair/', data),
  toggleDoNotPair:(id, data) => client.patch(`/do-not-pair/${id}/`, data),

  // Schedules
  getSchedules:  ()          => client.get('/schedules/'),
  getSchedule:   (id)        => client.get(`/schedules/${id}/`),
  publishSchedule:(id)       => client.post(`/schedules/${id}/publish/`),

  // Shift assignments (SSL edits)
  createShift:   (data)      => client.post('/shift-assignments/', data),
  updateShift:   (id, data)  => client.patch(`/shift-assignments/${id}/`, data),
  deleteShift:   (id)        => client.delete(`/shift-assignments/${id}/`),
};

export default scheduling;
